var _path, _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformationCircleGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.072 12C24.072 18.6274 18.6994 24 12.072 24C5.4446 24 0.0720215 18.6274 0.0720215 12C0.0720215 5.37258 5.4446 0 12.072 0C18.6994 0 24.072 5.37258 24.072 12ZM2.47202 12C2.47202 17.3019 6.77009 21.6 12.072 21.6C17.374 21.6 21.672 17.3019 21.672 12C21.672 6.69807 17.374 2.4 12.072 2.4C6.77009 2.4 2.47202 6.69807 2.47202 12Z",
    fill: "#E4F1EA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.072,
    cy: 12,
    r: 10,
    fill: "#E4F1EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4009_1397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0719 18.6663C15.7538 18.6663 18.7386 15.6816 18.7386 11.9997C18.7386 8.31778 15.7538 5.33301 12.0719 5.33301C8.39004 5.33301 5.40527 8.31778 5.40527 11.9997C5.40527 15.6816 8.39004 18.6663 12.0719 18.6663Z",
    stroke: "#2C303B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.072 14.6667V12",
    stroke: "#2C303B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.072 9.33301H12.0783",
    stroke: "#2C303B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4009_1397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4.07202 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircleGreen);
export default __webpack_public_path__ + "static/media/information-circle-green.6e1e310568ad09887d89509b045d7216.svg";
export { ForwardRef as ReactComponent };